import type { HTMLAttributes } from 'react';
import { cx } from '@parrot/utils';
import styles from './Spinner.module.css';

type Props = Omit<HTMLAttributes<HTMLSpanElement>, 'children'> & {
  /** `xs` sits inside a button, `lg` anchors a full-page wait. */
  size?: 'xs' | 'sm' | 'md' | 'lg';
  /**
   * Announced while the spinner is visible. Pass `undefined` when something
   * adjacent already describes the wait, so it isn't read out twice.
   */
  label?: string;
};

const SPOKES = [0, 1, 2, 3, 4, 5, 6, 7];

/** Indeterminate progress. Inherits `currentColor`, so set the colour on a parent. */
export const Spinner = ({ size = 'sm', label = 'Loading', className, ...spanProps }: Props) => (
  <span
    role={'status'}
    aria-label={label}
    className={cx(styles.base, styles[size], className)}
    {...spanProps}
  >
    {SPOKES.map((spoke) => (
      <span key={spoke} className={styles.spoke} />
    ))}
  </span>
);
